/** One stock report: its filters live in the URL so a report can be bookmarked or shared. */
import {
  STOCK_REPORT_PERMISSION,
  isStockReportSlug,
  stockReportKey,
} from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { StockReportPage } from "@/features/reports/stock/stock-reports-pages";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/stock/$slug")({
  validateSearch: reportSearch,
  // The report's own code opens it (each report has one, as every report does).
  beforeLoad: ({ params }) => {
    if (!isStockReportSlug(params.slug))
      throw redirect({ to: "/reports/stock" });
    const code = STOCK_REPORT_PERMISSION[stockReportKey(params.slug)];
    if (!useAuth.getState().can(code)) throw redirect({ to: "/reports/stock" });
  },
  component: Page,
});

function Page() {
  const { slug } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  if (!isStockReportSlug(slug)) return null;
  return (
    <StockReportPage
      key={slug}
      slug={slug}
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
